import { useAppStore } from '@/store/appStore';
import { cn } from '@/lib/utils';
import { Search, Bell, ChevronDown, ChevronDown as TenantIcon } from 'lucide-react';
import { Dropdown, DropdownItem, DropdownSeparator } from '@/components/ui/Dropdown';
import { StatusDot } from '@/components/ui/Badge';
import { api } from '@/api/client';

export function Header() {
  const setCommandPaletteOpen = useAppStore((s) => s.setCommandPaletteOpen);
  const setNotificationOpen = useAppStore((s) => s.setNotificationOpen);
  const wsConnected = useAppStore((s) => s.wsConnected);

  return (
    <header className="flex items-center gap-3 h-14 px-4 border-b border-border bg-base-panel shrink-0">
      {/* Search / Command palette trigger */}
      <button
        onClick={() => setCommandPaletteOpen(true)}
        className="flex items-center gap-2 w-64 h-8 px-3 rounded-md border border-border bg-base-bg text-text-muted text-xs hover:border-border-strong transition-colors"
      >
        <Search className="h-3.5 w-3.5" />
        <span>Search or jump to…</span>
        <kbd className="ml-auto text-2xs bg-base-elevated px-1.5 py-0.5 rounded border border-border">⌘K</kbd>
      </button>

      <div className="flex-1" />

      {/* Connection status */}
      <div className="flex items-center gap-2 text-xs text-text-muted">
        <StatusDot status={wsConnected ? 'online' : 'offline'} />
        <span>{wsConnected ? 'Connected' : 'Disconnected'}</span>
      </div>

      {/* Tenant selector */}
      <Dropdown
        align="right"
        trigger={
          <button className="flex items-center gap-2 px-2.5 h-8 rounded-md hover:bg-base-hover transition-colors text-xs">
            <span className="text-text-secondary">Acme MSP</span>
            <TenantIcon className="h-3 w-3 text-text-muted" />
          </button>
        }
      >
        <DropdownItem>Acme MSP</DropdownItem>
        <DropdownItem>TechSolutions MSP</DropdownItem>
        <DropdownSeparator />
        <DropdownItem icon={<span className="text-xs">+</span>}>Add Tenant</DropdownItem>
      </Dropdown>

      {/* Notifications */}
      <button
        onClick={() => setNotificationOpen(true)}
        className="relative h-8 w-8 flex items-center justify-center rounded-md hover:bg-base-hover transition-colors"
      >
        <Bell className="h-4 w-4 text-text-secondary" />
        <span className="absolute top-1.5 right-1.5 h-1.5 w-1.5 rounded-full bg-status-critical" />
      </button>

      {/* User profile */}
      <Dropdown
        align="right"
        trigger={
          <button className="flex items-center gap-2 px-1.5 h-8 rounded-md hover:bg-base-hover transition-colors">
            <div className="h-6 w-6 rounded-full bg-accent flex items-center justify-center text-xs font-medium text-accent-fg">
              JS
            </div>
            <ChevronDown className="h-3 w-3 text-text-muted" />
          </button>
        }
      >
        <div className="px-3 py-2">
          <div className="text-xs font-medium">John Smith</div>
          <div className="text-2xs text-text-muted">john.smith@insightnode.io</div>
        </div>
        <DropdownSeparator />
        <DropdownItem>Profile Settings</DropdownItem>
        <DropdownItem>API Keys</DropdownItem>
        <DropdownItem>Session Management</DropdownItem>
        <DropdownSeparator />
        <DropdownItem danger onClick={() => { api.clearTokens(); window.location.hash = '#/login'; }}>Sign Out</DropdownItem>
      </Dropdown>
    </header>
  );
}
